import cx from 'classnames';
import PT from 'prop-types';
import styles from './SuccessMeasure.scss';

const SuccessMeasureOption = ({
  label,
  IconComponent,
  value,
  setValue,
  selectedValue,
  setSaved,
}) => {
  return (
    <button
      className={cx(styles['optionButton'], {
        [styles['notSelected']]: selectedValue && value !== selectedValue,
      })}
      onClick={() => {
        setValue(value), setSaved(false);
      }}
      type="button"
      data-test="success-measure-option-wrap"
    >
      <IconComponent />
      <span>{label}</span>
    </button>
  );
};

export default SuccessMeasureOption;

SuccessMeasureOption.propTypes = {
  IconComponent: PT.func,
  label: PT.string,
  value: PT.string,
  selectedValue: PT.string,
  setValue: PT.func,
  setSaved: PT.func,
};
